import $ from 'jquery';

String.prototype.replaceDict = function(d) {
  let newString = this.toString();
  Object.entries(d).forEach(([k, v]) => {
    newString = newString.replaceAll(`{{ ${k} }}`, v);
  });
  return newString;
}

class FormInput {
  types = {
    number: '<input type="number" name="{{ name }}" id="{{ name }}" class="form-control">',
    email: '<input data-pristine-maxlength="150" type="text" name="{{ name }}" id="{{ name }}" class="form-control">',
    phone: '<input type="text" pattern="/05\\d{8}/" name="{{ name }}" id="{{ name }}" class="form-control" onkeyup="this.value=this.value.replace(/[^\\d]/,\'\')">',
    text: '<input type="text" name="{{ name }}" id="{{ name }}" class="form-control">'
  };
  base = '<div class="md-form form-group">' +
    '{{ input }}' +
    '<label class="form-label {{ active }}" for="{{ name }}" id="label_{{ name }}">{{ label }}</label>' +
    '</div>';

  constructor({name, label, active, type, required = false, defaultValue, validateMsg}) {
    if (!this.types.hasOwnProperty(type)) {
      type = 'text';
    }

    let input = $(this.types[type], {name});

    if (required) {
      input.attr('required', 'required');
      if (validateMsg.hasOwnProperty('required')) {
        input.attr('data-pristine-required-message', validateMsg['required']);
      }
    }

    if (validateMsg.hasOwnProperty(type)) {
      const typeMap = {
        // email: 'email',
        phone: 'pattern'
      }

      if (typeMap.hasOwnProperty(type) && type !== 'email') { // email have custom validation regex
        input.attr(`data-pristine-${typeMap[type]}-message`, validateMsg[type]);
      }
    }

    function capitalizeFirstLetter(val) {
      return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }

    label = capitalizeFirstLetter(label);

    this.$element = $(this.base.replaceDict({input: input[0].outerHTML, name, label, active, type, required, defaultValue}));
    if (defaultValue) {
      this.$element.children('input').val(defaultValue);
    }
  }

  prependTo(el) {
    this.$element.prependTo(el);
  }
}

export default FormInput;
